import { useMemo } from 'react';
import { getGroundTripWarnings } from '@lp/features/RoutePlanner/utils';
import { TmdxDriveAffiliateGroundLeg, TmdxDriveTedsGroundLeg } from '@/api/apis/route';
import { useDriveTripQuery } from '@/queries/drive-service';

export const useDriveTripWarnings = (leg: TmdxDriveAffiliateGroundLeg | TmdxDriveTedsGroundLeg) => {
  const { data } = useDriveTripQuery(leg.tripReference?.tripId);

  return useMemo(() => {
    if (!data || !leg) return [];

    return getGroundTripWarnings(leg, data);
  }, [leg, data]);
};
